// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.categoriesContainer {
  width: 80%;
  margin: 20px auto;
}

.header {
  width: 80%;
  margin: auto;
}

.navbar {
  display: flex;
  width: 100%;
  justify-content: flex-start !important;
  margin: 50px 0px;
}

.border {
  position: relative;
  bottom: 63px;
  z-index: 1;
  border-bottom: 5px solid #d2d3d4 !important;
}

.categoriesContainer>h2 {
  font-family: Thicker;
  color: #ba1e24;
  font-size: clamp(20px, 4vw, 24px) !important;
  font-weight: 400;
}

.categoriesContainer>h1 {
  color: #000;
  font-family: Thicker;
  font-size: clamp(30px, 4vw, 54px) !important;
  font-weight: 600;
  margin-top: 120px;
}

.categoriesContainer>p {
  color: #000;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-style: normal;
  font-family: lightThicker !important;
  margin: 20px auto !important;
}

.tabActive {
  color: #ba1e24;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 600;
  margin-right: 40px;
  padding-bottom: 8px;
  cursor: pointer;
  z-index: 2;
  border-bottom: 4px solid #ba1e24;
}

.disable {
  color: #000;
  padding-bottom: 10px;
  font-size: clamp(16px, 4vw, 20px) !important;
  font-weight: 500;
  margin-right: 40px;
  cursor: pointer;
}

.bannerPara {
  color: #fff !important;
  font-size: 32px !important;
}

.bannerDiv>div {
  display: block !important;
}

.bannerDiv>div>h1 {
  color: #fff !important;
  font-size: clamp(20px, 4vw, 32px) !important;
  position: absolute !important;
  bottom: 80px !important;
  left: 80px !important;
}

.bannerDiv>div>p {
  position: absolute !important;
  bottom: 40px !important;
  color: #fff !important;
  font-size: clamp(14px, 4vw, 20px) !important;
  font-weight: 400;
  font-family: lightThicker !important;
  left: 80px !important;
}

.bannerDiv>img {
  position: relative !important;
  display: inline-block !important;
  content: "" !important;
  width: 100% !important;
  height: 100% !important;
  background-image: linear-gradient(45deg,
      rgba(245, 70, 66, 0.75),
      rgba(8, 83, 156, 0.75)),
    url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/Rectangle+313+(3).png");
}

@media screen and (max-width: 1200px) {
  .categoriesContainer {
    width: 90%;
  }

  .header {
    width: 90%;
  }
}

@media screen and (max-width: 800px) {
  .bannerDiv>div>h1 {
    position: absolute !important;
    bottom: 70px !important;
    left: 50px !important;
  }

  .bannerDiv>div>p {
    position: absolute !important;
    bottom: 40px !important;
    font-weight: 400;
    left: 50px !important;
  }
}

@media screen and (max-width: 600px) {
  .categoriesContainer>h1 {
    margin-top: 70px;
    margin-bottom: 5px;
  }

  .categoriesContainer>p {
    margin-top: 5px;
  }

  .active {
    margin-right: 3px;
  }

  .disable {
    margin-right: 3px;
  }

  .navbar {
    margin: 10px 0px;
  }

  .border {
    position: relative;
    bottom: 13px;
    z-index: 1;
    border-bottom: 5px solid #d2d3d4;
  }

  .bannerDiv>div>h1 {
    position: absolute !important;
    bottom: 33px !important;
    left: 30px !important;
    font-size: 18px !important;
  }

  .bannerDiv>div>p {
    position: absolute !important;
    bottom: -5px !important;
    text-align: left;
    color: #fff !important;
    font-weight: 400;
    left: 30px !important;
    line-height: 15px;
    font-size: 14px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/categories/categories.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,4CAA4C;EAC5C,kBAAkB;EAClB,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,4CAA4C;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,4CAA4C;EAC5C,6BAA6B;EAC7B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,gBAAgB;EAChB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB;;;0GAGwG;AAC1G;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gCAAgC;EAClC;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,qBAAqB;IACrB,0BAA0B;EAC5B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;IACjB,0BAA0B;EAC5B;AACF","sourcesContent":[".categoriesContainer {\n  width: 80%;\n  margin: 20px auto;\n}\n\n.header {\n  width: 80%;\n  margin: auto;\n}\n\n.navbar {\n  display: flex;\n  width: 100%;\n  justify-content: flex-start !important;\n  margin: 50px 0px;\n}\n\n.border {\n  position: relative;\n  bottom: 63px;\n  z-index: 1;\n  border-bottom: 5px solid #d2d3d4 !important;\n}\n\n.categoriesContainer>h2 {\n  font-family: Thicker;\n  color: #ba1e24;\n  font-size: clamp(20px, 4vw, 24px) !important;\n  font-weight: 400;\n}\n\n.categoriesContainer>h1 {\n  color: #000;\n  font-family: Thicker;\n  font-size: clamp(30px, 4vw, 54px) !important;\n  font-weight: 600;\n  margin-top: 120px;\n}\n\n.categoriesContainer>p {\n  color: #000;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-style: normal;\n  font-family: lightThicker !important;\n  margin: 20px auto !important;\n}\n\n.tabActive {\n  color: #ba1e24;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 600;\n  margin-right: 40px;\n  padding-bottom: 8px;\n  cursor: pointer;\n  z-index: 2;\n  border-bottom: 4px solid #ba1e24;\n}\n\n.disable {\n  color: #000;\n  padding-bottom: 10px;\n  font-size: clamp(16px, 4vw, 20px) !important;\n  font-weight: 500;\n  margin-right: 40px;\n  cursor: pointer;\n}\n\n.bannerPara {\n  color: #fff !important;\n  font-size: 32px !important;\n}\n\n.bannerDiv>div {\n  display: block !important;\n}\n\n.bannerDiv>div>h1 {\n  color: #fff !important;\n  font-size: clamp(20px, 4vw, 32px) !important;\n  position: absolute !important;\n  bottom: 80px !important;\n  left: 80px !important;\n}\n\n.bannerDiv>div>p {\n  position: absolute !important;\n  bottom: 40px !important;\n  color: #fff !important;\n  font-size: clamp(14px, 4vw, 20px) !important;\n  font-weight: 400;\n  font-family: lightThicker !important;\n  left: 80px !important;\n}\n\n.bannerDiv>img {\n  position: relative !important;\n  display: inline-block !important;\n  content: \"\" !important;\n  width: 100% !important;\n  height: 100% !important;\n  background-image: linear-gradient(45deg,\n      rgba(245, 70, 66, 0.75),\n      rgba(8, 83, 156, 0.75)),\n    url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/Rectangle+313+(3).png\");\n}\n\n@media screen and (max-width: 1200px) {\n  .categoriesContainer {\n    width: 90%;\n  }\n\n  .header {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .bannerDiv>div>h1 {\n    position: absolute !important;\n    bottom: 70px !important;\n    left: 50px !important;\n  }\n\n  .bannerDiv>div>p {\n    position: absolute !important;\n    bottom: 40px !important;\n    font-weight: 400;\n    left: 50px !important;\n  }\n}\n\n@media screen and (max-width: 600px) {\n  .categoriesContainer>h1 {\n    margin-top: 70px;\n    margin-bottom: 5px;\n  }\n\n  .categoriesContainer>p {\n    margin-top: 5px;\n  }\n\n  .active {\n    margin-right: 3px;\n  }\n\n  .disable {\n    margin-right: 3px;\n  }\n\n  .navbar {\n    margin: 10px 0px;\n  }\n\n  .border {\n    position: relative;\n    bottom: 13px;\n    z-index: 1;\n    border-bottom: 5px solid #d2d3d4;\n  }\n\n  .bannerDiv>div>h1 {\n    position: absolute !important;\n    bottom: 33px !important;\n    left: 30px !important;\n    font-size: 18px !important;\n  }\n\n  .bannerDiv>div>p {\n    position: absolute !important;\n    bottom: -5px !important;\n    text-align: left;\n    color: #fff !important;\n    font-weight: 400;\n    left: 30px !important;\n    line-height: 15px;\n    font-size: 14px !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
